/* eslint-disable react/prop-types */
import {
  ArrowLeftOutlined,
  DeleteOutlined,
  EditOutlined,
  ExportOutlined,
  EyeOutlined,
  FilePdfOutlined,
  FilterOutlined,
} from '@ant-design/icons';
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Space,
  Table,
  Tooltip,
  Typography,
  Select,
  notification,
  Tag,
  Row,
  Col,
  Drawer,
} from 'antd';
import { get, set } from 'lodash';
import React, { useState, useRef, useMemo, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';

import ExcelJS from 'exceljs';
import moment from 'moment';
import history from '../../services/history';
import ProjectDetails from './ProjectDetails';
import TechnicalReportPage from './TechnicalReportPage';

import PDFViewer from './PDFViewer';
import { fetchProjectList } from '../../redux/CRCETechnical/action';
import {
  getCategoryListFromDatabse,
  getExportDataListFromDatabse,
} from '../../redux/CRCETechnical/saga';
import { object } from 'prop-types';
import UpdateReport from './UpdateReport';
import logoCrc from '../../assets/logoCrc.png';
//ag grid enterprise
import 'ag-grid-enterprise';
import { LicenseManager } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { MenuModule } from '@ag-grid-enterprise/menu';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import { StatusBarModule } from '@ag-grid-enterprise/status-bar';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { CustomLoadingCellRenderer } from './Uitiles';

// import axiosConfig from './axiosConfig';
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  ColumnsToolPanelModule,
  FiltersToolPanelModule,
  MenuModule,
  SetFilterModule,
  StatusBarModule,
  RowGroupingModule,
]);

LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_ENTERPRISE_LICENSE);

const { Option } = Select;
const { Title, Text } = Typography;

const TechnicalPageAgGrid = (props) => {
  const { projectList, isLoading, listCount, onProjectList, listTotalCount } = props;
  const data = [
    {
      key: '1',
      MaterialName: '3M Scotchkote 226N FBE_Borealis EP5 10/60M CMPP_Borealis EP5 10/60 PP Tape',
      BatchNumber: 'IN02 5E14_PL101HX01_NH1341E01',
      TestedDate: '2024-01-15',
      ReportedDate: '2024-02-20',
      // Add other properties as needed
    },
    {
      key: '1',
      MaterialName: '3M Scotchkote 226N ',
      BatchNumber: 'IN02 / 4L10 (804)',
      TestedDate: '2024-01-15',
      ReportedDate: '2024-02-20',
      // Add other properties as needed
    },
    // Add more objects as needed
  ];

  const [theme, setTheme] = useState('ag-theme-material-dark'); // Default theme
  const gridRef = useRef();

  const [showAddNewModal, setShowAddNewModal] = useState(false);
  const [addNewForm] = Form.useForm();
  const [showTestPage, setshowTestPage] = useState(false);
  const [selectedRow, setSelectedRow] = useState('');
  const [isEdit, setIsEdit] = useState(false);
  const [editRecord, seteditRecord] = useState('');
  const [current, setCurrent] = useState(1);
  const [currentPagesize, setCurrentPagesize] = useState(10);
  const [prevPageNumber, setPrevPageNumber] = useState(1);
  const [prevPagesize, setPrevPagesize] = useState(10);
  const [selectedProject, setSelectedProject] = useState('');
  //const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const [resultModalVisible, setResultModalVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [categoryType, setCategoryType] = useState([]);
  const [materialType, setMaterialType] = useState([]);
  const [selectedMaterial, setSelectedMaterial] = useState([]);
  const [temperatureType, setTemperatureType] = useState([]);
  const [fileNameType, setFileNameType] = useState([]);
  const [selectedTemperature, setSelectedTemperature] = useState([]);
  const [selectedFileName, setSelectedFileName] = useState([]);
  const [timelineType, setTimelineType] = useState([]);
  const [selectedTimeline, setSelectedTimeline] = useState([]);
  const [projectNameType, setProjectNameType] = useState([]);
  const [selectedProjectName, setSelectedProjectName] = useState([]);
  const [matrialSearchType, setMatrialSearchType] = useState('');
  const [testTypeSearchType, setTestTypeSearchType] = useState('');
  const [projectNameSearchType, setProjectNameSearchType] = useState('');
  const [timelineSearchType, setTimelineSearchType] = useState('');
  const [temperatureSearchType, setTemperatureSearchType] = useState('');
  const [fileNameSearchType, setFileNameSearchType] = useState('');
  const [searchType, setSearchType] = useState({});
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [searchCriteria, setSearchCriteria] = useState({});
  const [searchFilterCriteria, setSearchFilterCriteria] = useState({});
  const [rowData, setRowData] = useState([]);
  const columnList = {
    ID: 'ID',
    Material: 'Material',
    TestType: 'Test Type',
    Vendor: 'Vendor',
    ProjectName: 'Project Name',
    Timeline: 'Timeline',
    Temperature: 'Temperature',
    WallThickness: 'Wall Thickness',
    PipeDiameter: 'Pipe Diameter',
    Company: 'Company',
    Contractor: 'Contractor',
    FileName: 'File Name',
    ReportNumber: 'Report Number',
    TestedDate: 'Tested Date',
    ReportedDate: 'Report Date',
  };

  const [columnDefs, setColumnDefs] = useState([]);

  const generateColumns = (columnList, onReadParts) => {
    const columnDefs = Object.keys(columnList).map((key, index) => ({
      field: key,
      headerName: columnList[key],
      key: key,
      cellRenderer: (params) => {
        const isDateColumn = key === 'TestedDate' || key === 'ReportedDate';
        return isDateColumn && params.value
          ? moment(params.value).format('DD-MMM-YYYY')
          : params.value;
      },
      cellStyle: { textAlign: 'center' },
      headerClass: 'ag-center-header',
      filter: 'agMultiColumnFilter',
      filterParams: {
        filters: [
          {
            filter: 'agTextColumnFilter',
            filterParams: {
              filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
              buttons: ['reset'],
            },
          },
          {
            filter: 'agSetColumnFilter',
            filterParams: {
              buttons: ['reset'],
            },
          },
        ],
      },
    }));
    // Add the actions column at the end
    columnDefs.push({
      headerName: 'Results',
      field: 'results',
      cellRenderer: (params) => {
        const record = params.data;
        const hasSingleItem = getResultsItems(record.Results);
        let itemValue = '';
        // if (hasSingleItem)
        itemValue = getResultsItemsValue(record.Results);
        // console.log(hasSingleItem)
        // console.log(itemValue)
        return (
          <>
            {hasSingleItem || itemValue === '_' ? (
              <a>{itemValue === '_' ? '-' : itemValue}</a>
            ) : (
              <Tooltip title="Results">
                <span
                  className="icon-18 mr-2 cursor-pointer edit-hover"
                  style={{ marginRight: '00px' }}
                >
                  <EyeOutlined
                    style={{ fontSize: '18px' }}
                    onClick={() => onReadParts(record)}
                  />
                </span>
              </Tooltip>
            )}
          </>
        );
      },
      cellStyle: { textAlign: 'center' },
      filter: false, // Disable filtering for the Actions column
    });

    // Add the actions column at the end
    columnDefs.push({
      headerName: 'Actions',
      field: 'action',
      pinned: 'right',
      cellRenderer: (params) => {
        const record = params.data;
        return (
          <div>
            <Tooltip title="View  Report">
              <Button
                className="p-0 border-0"
                size="small"
                target="_blank"
                style={{ marginRight: '20px' }}
              >
                <FilePdfOutlined
                  className="pdfIconRed"
                  onClick={() => onClickPDFView(record)}
                />
              </Button>
            </Tooltip>
            <Tooltip title="Update">
              <span className="icon-18 mr-2 cursor-pointer edit-hover">
                <EditOutlined
                  style={{ paddingRight: '0px' }}
                  onClick={() => onUpdateClick(record)}
                />
              </span>
            </Tooltip>
          </div>
        );
      },
      cellStyle: { textAlign: 'center' },
      filter: false, // Disable filtering for the Actions column
    });
    setColumnDefs(columnDefs);

    return columnDefs;
  };

  useEffect(() => {
    console.log('rawDataList updated:', projectList.length);

    if (projectList.length > 0) generateColumns(columnList, onReadParts);
    setRowData(projectList);
  }, [projectList]);

  const getResultsItems = (data) => {
    if (!data) return false;
    const dataArray = Object.entries(data).map(([key, value]) => ({
      label: key,
      value: value,
    }));

    if (dataArray && dataArray.length == 1) {
      try {
        //JSON.parse(dataArray[0].value)

        if (typeof dataArray[0].value == 'object') {
          //  console.log('json v', dataArray[0].value, data)
          return false;
        }
      } catch (error) {
        return false;
      }

      return true;
    } else return false;

    // return   typeof data === 'object' && data !== null
    //console.log(dataArray)
    //return dataArray.length == 1;
  };

  const getResultsItemsValue = (data) => {
    if (!data || typeof data !== 'object' || Object.keys(data).length === 0) {
      return '_'; // Return '_' if data is null, undefined, not an object, or empty
    }

    const dataArray = Object.entries(data).map(([key, value]) => ({
      label: key || '_', // Use '_' if the key is null or undefined
      value: value !== null && value !== undefined ? value : '_', // Use '_' if the value is null or undefined
    }));

    return dataArray && dataArray.length > 1 ? dataArray : dataArray[0]?.value || '_';
  };

  const onClickPDFView = (record) => {
    // Open PDF viewer in a new tab/window
    window.open(`/TechnicalPage/pdf/${record.ID}`, '_blank');
  };

  useEffect(() => {
    var obj = {
      pageSize: 100000,
      pageNumber: 1,
    };
    if (rowData.length == 0) onProjectList(obj);
  }, []);
  // useEffect(() => {

  //     // var obj = {
  //     //     pageSize: currentPagesize,
  //     //     pageNumber: 1,
  //     //     searchKey: searchCriteria
  //     // }
  //     // setCurrent(1)
  //     // onProjectList(obj)

  //     const isvalid = hasNonEmptyTag(searchCriteria)
  //     let obj = {
  //         pageSize: isvalid ? currentPagesize : prevPagesize,
  //         pageNumber: isvalid ? 1 : prevPageNumber,
  //         searchKey: searchCriteria
  //     };
  //     //console.log(obj);

  //     (async () => {
  //         // setSelectedMaterial([])
  //         if (isvalid) {
  //             setPrevPagesize(currentPagesize)
  //             setPrevPageNumber(current)
  //         }
  //         setCurrent(obj.pageNumber)
  //         await onProjectList(obj);
  //     })();

  // }, [searchCriteria]);
  useEffect(() => {
    if (!showAddNewModal) addNewForm.resetFields();
  }, [showAddNewModal]);
  const onReadParts = async (record) => {
    if (record) {
      // console.log(record)
      setSelectedRow(record);
      setResultModalVisible(true);
      //setshowTestPage(true)
    }
  };
  const onUpdateClick = (record) => {
    if (record) {
      // let editData = {
      //     projectName: record.ProjectName,
      //     projectNumber: record.ProjectNumber,

      // };
      addNewForm.setFieldsValue(record);
      addNewForm.setFieldsValue(record.Results);
      //console.log(record)
      seteditRecord(record);
      setIsEdit(true);
      setShowAddNewModal(true);
    }
  };
  // useEffect(() => {
  //     if (editRecord)
  //         setShowAddNewModal(true)

  // }, [editRecord])

  function hasNonEmptyTag(jsonObj) {
    for (const key in jsonObj) {
      if (jsonObj.hasOwnProperty(key)) {
        const value = jsonObj[key];
        console.log(jsonObj);

        if (Array.isArray(value) && value.length > 0) {
          return true;
        } else if (typeof value === 'string' && value.trim() !== '') {
          return true;
        }
      }
    }
    return false;
  }

  const renderKeyValuePairs = (obj, level = 0) => {
    return Object.entries(obj).map(([key, value]) => {
      if (value !== '_') {
        if (typeof value === 'object' && value !== null) {
          // Recursively render nested objects
          return (
            <div
              key={key}
              style={{ marginLeft: `${level * 20}px` }}
            >
              <strong>{key}</strong>:{renderKeyValuePairs(value, level + 1)}
            </div>
          );
        } else {
          // Render the key-value pair
          return (
            <div
              key={key}
              style={{ marginLeft: `${level * 20}px` }}
            >
              <strong>{key}</strong>: {value}
            </div>
          );
        }
      }
      return null;
    });
  };
  const addDropdownOptions = async (worksheet, columnLetter, options, startRow = 2) => {
    let optionsSheet = worksheet.workbook.getWorksheet('Options');

    if (!optionsSheet) {
      optionsSheet = worksheet.workbook.addWorksheet('Options');
      optionsSheet.state = 'veryHidden';
    }

    options.forEach((value, index) => {
      optionsSheet.getCell(`${columnLetter}${index + startRow}`).value = value;
    });

    for (let i = startRow; i < 1000; i++) {
      worksheet.getCell(`${columnLetter}${i}`).dataValidation = {
        type: 'list',
        allowBlank: true,
        formulae: [`=Options!$${columnLetter}$1:$${columnLetter}$9999`],
      };
    }
  };
  const handleDownloadFilterTable = async (filterData) => {
    setExportLoading(true);
    //console.log(filterData)
    const data = await createExcelTemplate();
    const blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Coating Technical Report.xlsx';
    link.click();
    setExportLoading(false);
  };

  const createExcelTemplate = async () => {
    var obj = {
      searchKey: searchCriteria,
    };
    const data = await getExportDataListFromDatabse(obj);
    if (data && data.length > 0) {
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet('Coating Technical Report');

      // Keys to skip
      const keysToSkip = ['ID', 'FileLink', 'totalCount', 'CreationDate', 'UpdatedDate'];

      // Function to flatten the object structure
      const flattenObject = (obj, parentKey = '', result = {}) => {
        for (const key in obj) {
          const propName = parentKey ? `${parentKey}_${key}` : key;
          if (keysToSkip.includes(key)) continue;
          if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
            flattenObject(obj[key], propName, result);
          } else {
            result[propName] = obj[key];
          }
        }
        return result;
      };

      const headers = new Set();
      const rows = [];

      data.forEach((item) => {
        const flattenedItem = flattenObject(item);
        Object.keys(flattenedItem).forEach((key) => {
          if (!keysToSkip.includes(key)) headers.add(key);
        });
        rows.push(flattenedItem);
      });

      const orderedHeaders = Array.from(headers);
      Array.prototype.myJoin = function (seperator, start, end) {
        if (!start) start = 0;
        if (!end) end = this.length - 1;
        end++;
        return this.slice(start, end).join(seperator);
      };
      // Define columns with hierarchical headers
      sheet.columns = orderedHeaders.map((header) => {
        if (header === 'Results_Result') {
          return { header: 'Results', key: header, width: 20 };
        } else if (header.startsWith('Results_Result')) {
          const headerParts = header.split('_');
          return { header: headerParts.myJoin(' -> ', 1, 2), key: header, width: 20 };
        } else {
          const headerParts = header.split('_');
          return { header: headerParts.join(' -> '), key: header, width: 20 };
        }
      });

      // Print the converted object
      //console.log('Converted Object', orderedHeaders, rows);

      // Add rows
      rows.forEach((rowData, index) => {
        const row = sheet.getRow(index + 2); // Start from the second row
        const orderedRowData = orderedHeaders.map((header) =>
          rowData[header] !== undefined ? rowData[header] : ''
        );
        orderedRowData.forEach((value, cellIndex) => {
          row.getCell(cellIndex + 1).value = value;
        });
        // console.log(row.values);
      });
      // Save the workbook to a buffer
      return await workbook.xlsx.writeBuffer();
    } else {
      notification.error({
        message: 'Filter data empty',
      });
    }
  };

  const handleDownloadSGSFrontSheetTemplate = async () => {
    const workbook = new ExcelJS.Workbook();
    const addStationSheet = workbook.addWorksheet('SGS front sheet');

    const headerRow = addStationSheet.getRow(1);
    headerRow.height = 40;

    const projectNames = [
      'Askeladd',
      'Askellad',
      'Bahr Essalam',
      'Barzan Onshore',
      'BPAKER KEG',
      'Colibri',
      'Culzean',
      'Edradour Glenlivet',
      'Fenja Development',
      'Future Growth Project',
      'Golfinho',
      'Greater Western Flank II',
      'GWF II Spools',
      'Ichthys',
      'Ichthys Spools',
      'Julimar',
      'Kaombo Flowlines',
      'Khazzan Galfar',
      'Lingshui',
      'Mero 1',
      'Mero 2',
      'Moheshkali Floating LNG',
      'NAM K15 - L13',
      'NFA Field Joints',
      'NFA Spools & Risers',
      'NFPS',
      'Peregrino 2 Surf',
      'Pupp Idoho',
      'Ras Markaz',
      'Rosehill',
      'Rota 3 - Tramo 2',
      'Scarborough',
      'Sepia',
      'Sepia 3LPP Onshore Tie-Ins',
      'Sepia 3LPP Post Bend',
      'TAP',
      'Technip Norge AS',
      'Tolmount',
      'Tortue PVT',
      'West Nile Delta',
      'Zinia',
    ];
    const testType = [
      'Hot Water Immersion',
      'Post-Bend Microscopic Analysis',
      'Thermal Conductivity',
      'Abrasion Test',
      'Adhesion',
      'Bond Test',
      'Brittleness Temperature',
      'Buchholz Hardness',
      'Cathodic Disbondment',
      'Coefficient Expansion',
      'Compressive strength',
      'Density',
      'Determination of Cure Rate',
      'Determination of Glass Transistion Temperature(Tg)',
      'Determination of Tensile Properties',
      'Di-electric Strength',
      'Dry and Saturated Density',
      'Dry Density',
      'FBE Adhesion',
      'FBE Visual Assessment',
      'Flexibility',
      'Flexural Modulus',
      'Hardness',
      'Heat Capacity',
      'Hot Water Immersion Post-Exposure',
      'Hot Water Soak',
      'Hot Water Soak + Pull-Off Adhesion',
      'Impact Resistance',
      'Indentation Resistance',
      'Interface Contamination',
      'Lap Shear',
      'Micro Exam of Cracks',
      'Multiple Test',
      'Oxidation Induction Time',
      'Peel Adhesion',
      'Peel Adhesion Post Hot Water Immersion',
      'Peel Steel',
      'Peel Weld',
      'Porosity',
      'Post Bend Tensile Adhesion',
      'Pre-Exposure X-Cut',
      'Primer Viscosity Analysis',
      'Pull Off Adhesion',
      'Pull off Adhesion Post Hot Water Immersion',
      'Pull off Adhesion to Overlap',
      'Pull off Adhesion to Steel',
      'Pull-Off Adhesion',
      'Ring Shear',
      'Sand Abrasion',
      'Saturated Density',
      'Sectioning',
      'Shore D Hardness',
      'Softening Point',
      'Specific Electrical Insulation Resistance',
      'Specific Heat Capacity',
      'Taber Abrasion',
      'Tensile Adhesion',
      'Tensile Adhesion Post Hot Water Immersion',
      'Tensile Properties',
      'Tg Analysis',
      'Thermal Ageing',
      'Thermal Ageing and Post Exposure Test',
      'Thermal Analysis',
      'Thermal Degradation',
      'Tri-Axial Compression Creep',
      'Vicat Softening',
      'Visual Assessment',
      'Volume Resistivity',
      'Water Absorption',
    ];
    const Company = [
      'ArcelorMittal Tubular Products Aktau',
      'Bonatti Tengiz Republic of Kazakhstan',
      'BP',
      'COEEC',
      'COOEC',
      'Equinor',
      'Excellerate Energy',
      'Inpex',
      'Maersk',
      'MPN',
      'Neptune',
      'OTTCO',
      'Petrobras',
      'Qatar Gas',
      'Qatar Petroleum',
      'QG',
      'QP',
      'Shell',
      'TCO',
      'Total',
      'Total E&P UK Limited',
      'Trans Adriatic Pipeline AG',
      'Unknown',
      'Woodside',
    ];
    const contractor = [
      'Bonatti J&P Avax S.r.l JV',
      'COOEC',
      'CPP',
      'CRCE',
      'Galfar',
      'Geocean',
      'Heerema Marine Contractors',
      'KTR',
      'McDermott',
      'McDermott Eastern Hemisphere Ltd',
      'Saipem',
      'Subsea 7',
      'Subsea7',
      'Technip',
      'Technip Norge AS',
      'TechnipFMC',
      'Unknown',
      'Van Oord',
    ];
    const material1 = [
      '3M scotchkote 226N',
      '3M Scotchkote 226N FBE',
      '3M Scotchkote 626-40 FBE',
      'Akzo Nobel Resicoat R-726 LAT FBE',
      'Axalta Nap-Gard 7-2500 FBE',
      'BASF H2100/71 HDPUF',
      'BASF H2100/78',
      'BASF H2100/78 Polyol',
      'Borealis Borcoat BB127E',
      'Borealis Borcoat BB127E-PW',
      'Borealis Borcoat EA165E PP',
      'Borealis EA165E IMPP',
      'Borealis EA165E PP',
      'Canusa CPS Liquid Epoxy',
      'Canusa GTS 65 HSS',
      'Canusa GTS PP HSS',
      'Canusa GTS-PP',
      'Canusa GTS-PP 100 HSS',
      'Canusa HBE -OS',
      'Canusa KLNN Heat Shrink Sleeve',
      'Canusa Liquid Epoxy E-Primer',
      'Canusa Liquid Epoxy Primer',
      'Canusa MIS 65 HSS',
      'Canusa P Primer',
      'Canusa P-Primer',
      'CMPP HX EP5 10/60 M Bianco',
      'FBE - Scotchcote 226N',
      'FBE Jotupipe-LT7011',
      'High Density Polyurethane Foam',
      'Jotapipe AC 1003 FBE',
      'Jotupipe-LT7011 FBE',
      'Pipeclad 2000',
      'Pipeclad 2000 FBE',
      'Pipeclad 2000 Slow Gel FBE',
      'Pipeclad 2000 Sloww Gel FBE',
      'Protegol 32-55 PN Comp A',
      'Protegol 32-55 PN_M-L Comp A',
      'Protegol 32-60 Comp A',
      'Safoam PN-40-E',
      'Scotchkote 226N FBE',
      'Sherwin Williams HOT120 Flex FBE',
      'Sherwin Williams HOT150 Flex FBE',
      'Valspar HOT 120 FBE',
      'Valspar Hot 150',
      'Valspar Pipeclad 2000 FBE',
      'Valspar Pipeclad 2000 Slow Gel FBE',
      'Valspar Pipeclad HOT 150',
      'Valspar Pipeclad Hot 150 FBE',
      'Valspar Pipeclad HOT 150 Flex FBE',
      'Valspar Pipeclad LAT 2000',
    ];
    const material2 = [
      'Basell Hifax 10/60M',
      'Basell Hifax EP5 10/60E PP Tape',
      'Borealis BB127E CMPP',
      'Hifax Bianco EP5 10/60M CMPP',
      'Hifax EPS 10/60M Bianco',
      'Rosehill RS 3173 IMPU',
      'Rosehill RS 3604 IMPU',
      '342Y081704',
      'Axalta Nap-Gard 7-2504 FBE',
      'Basell 10/60 EP 10-60M',
      'Basell Hifax 10/60M',
      'Basell Hifax EP5 10/60E PP Tape',
      'Basell Hifax EPS 10/6E PP Tape',
      'BASF PMDI 92140',
      'BASF PMDI 92140 Iso',
      'Borcoat BB127E-PW CMPP',
      'Borealis BB127E CMPP',
      'Borealis BB127E-PW CMPP',
      'Borealis Borcoat BB127E',
      'Borealis Borcoat BB127E-PW CMPP',
      'Borealis EA165E IMPP',
      'Borealis EP5 10/60M CMPP',
      'Borealis EPR 60 Bianco CMPP',
      'Borealis EPR 60 Bianco FSPP',
      'Borocaot BB127E-PW CMPP',
      'Canusa E Primer',
      'Canusa E-Primer',
      'Canusa GTS PP',
      'Canusa GTS PP HSS',
      'Canusa GTS-PP Heat Shrink Sleeve',
      'Canusa GTS-PP HSS',
      'CMPP HX EP5 10/60 M Bianco',
      'ColourHouse CUS1751',
      'Dow Hyperlast FJ 7004 Polyol',
      'EP5 10/60 M CMPP',
      'EP5 10/60 M Flame Spray',
      'EP5 10/60 M Tape Wrap',
      'EPS 10/60M CMPP',
      'Flexion RS3060 IMPU',
      'GTS-PP200-450 WS BK/S Heat Shrink Sleeve',
      'Hifax Bianco EP5 10/60M CMPP',
      'LyondellBasell PP HX EPS 10/60 M',
      'LyondellBasell Hifax EP5/60M PP',
      'Protegol 32-55 PN Comp B',
      'Protegol 32-55 PN_M-L Comp B',
      'Protegol 32-60 Comp B',
      'Reedy Chemicals Safoam PN 40-E',
      'Rosehill Flexilon C35467',
      'Rosehill Flexilon R3173',
      'Safoam PN40-E Foaming Agent',
      'Safoam PN-40-E Foaming Agent',
      'Valspar Pipeclad 2040 Flex LAT',
    ];
    const material3 = [
      'Borealis EA165E IMPP',
      'Rosehill FLEXILON i3173',
      'Rosehill FLEXILON i3604',
      'Basell 10/60 EP 5',
      'Borealis Borcoat EA165E PP',
      'Borealis EA165E',
      'Borealis EA165E IMPP',
      'Borealis EA165E PP',
      'Borealis EA165E PP Pellets',
      'Borealis EP5 10/60 PP Tape',
      'Borealis EP5 10/60E PP Tape',
      'Borealis EP5 10/60M PP Flamespray',
      'Canusa GTS-PP Heat Shrink Sleeve',
      'CUS 1751 Pigment',
      'CUS1751 Pigment',
      'Dow Hyperlast FJ 6609 Iso',
      'EP5 10/60 Bianco PP Tape',
      'EPS 10/60M PP Flamespray',
      'GTS-PP HSS',
      'GTS-PP200-450 WS BK/S Heat',
      'Reedy Chemicals Safoam PN 40-E',
      'Rosehill I3173',
    ];
    const material4 = [
      'Rosehill FLEXILON C3173',
      'Rosehill FLEXILON C3604',
      '_',
      'Borcoat EA165E IMPP',
      'Borealis Borcoat EA165E PP',
      'Borealis EP5 10/60E PP Tape',
      'Safoam PN40-E Foaming Agent',
      'Safoam PN-40E Foaming Agent',
      'Shrink Sleeve',
    ];
    const material5 = ['CUS1751 Pigment', 'Normatch 26-9124MB Pigment'];
    const temperature = [
      '-30 Deg c',
      '-20 Deg c',
      '-20 to 140 Deg c',
      '-5 Deg c',
      '0 Deg c',
      '5 Deg c',
      '10 to -30 Dec c',
      '20 Deg c',
      '21 Deg c',
      '23 Deg c',
      '23.3 Deg C',
      '23.6 Deg c',
      '23.8 Deg C',
      '24 Deg c',
      '25 Deg c',
      '30 Deg c',
      '50 Deg c',
      '55 Deg c',
      '60 Deg c',
      '63 Deg c',
      '65 Deg c',
      '66 Deg c',
      '80 Deg c',
      '81 Deg c',
      '84 Deg c',
      '85 Deg c',
      '90 Deg c',
      '94 Deg c',
      '95 Deg c',
      '100 Deg c',
      '101 Deg c',
      '104 Deg c',
      '110 Deg c',
      '120 Deg C',
      '121 Deg C',
      '134 Deg c',
      '140 Deg c',
      '150 Deg C',
      '180 Deg c',
    ];
    const timeline = [
      '6 Hours',
      '14 Days',
      '15 Mins',
      '16 Hours',
      '21 Days',
      '24 Hours',
      '28 Days',
      '30 Days',
      '40 Hours',
      '48 Hours',
      '49 Hours',
      '60 Days',
      '100 Days',
      '100 Hours',
      '168 Hours',
      '7 Days',
    ];
    const batchNumber1 = [
      '042Y042226',
      '052Y042653',
      '072Y043853',
      '0T2Y047824',
      '0V2Y048112',
      '0W2Y049878',
      '112Y052339',
      '122Y052339',
      '142Y054329',
      '1616402-1',
      '17-B-18',
      '19-A-682',
      '22-B-1307',
      '242Y070303',
      '342Y081704',
      '342Y081706',
      '501084',
      '5J11A-31A',
      '5T36033613',
      '608018',
      '608024A',
      '62108002-4',
      '73200187',
      '842Y020754',
      '8V2Y027986',
      '912Y029599',
      'B-61902006',
      'H61707008-7',
      'HV26002006',
      'HV61707008',
      'HV61902002',
      'HV61912002',
      'HV62002006',
      'IN02 / 4L10 (804)',
      'IN02 5E14',
      'IN02 5L02',
      'IN02 6E20',
      'IN-7E13-1',
      'IN-7K22-3',
      'IN-9B15B-2',
      'IN8J29B/1',
      'OV2YO48112',
      'QA-11-B-1716LG',
      'QA-11-B1716LG.0',
      'QA-16-B-1874',
      'QA-17-A-145',
      'QA-17-B-875',
      'S225195002',
      'VB12994RE',
      'XD291HXAF',
    ];
    const batchNumber2 = [
      '0W2Y049876',
      '10L19A90H0',
      '15-B-959',
      '1616042',
      '1616042-1',
      '1617072-2',
      '16989',
      '17-B-2906',
      '18-B-1317',
      '19-A-682',
      '19-A-743',
      '20-A-66',
      '21-A-484',
      '311-9647',
      '311-9653',
      '4053728',
      '706014B',
      '832-4485',
      '849-4977',
      'AB151HXAA',
      'C51908002',
      'CP11405067',
      'F368J1F001',
      'ISO 1288014',
      'P1DF003670',
      'PL101HX01',
      'RA61612014 02334',
      'RC01 HX01',
      'RF2441E02',
      'RG151HXAD',
      'S224206011',
      'S224612024',
      'S225195002',
      'S225242005',
      'S2255195002',
      'SRG151HXAD',
      'UE021 HXAB',
      'XB181HXAA',
      'XD291',
      'XD291HXAF',
      'XE151HXAG',
    ];
    const batchNumber3 = [
      '14253',
      '16403',
      '311-9650',
      '311-9655',
      '73160601',
      '63151008',
      '73150400',
      '73160863',
      '73200187',
      '73200641',
      '849-4978',
      '1616042-1',
      '18-B-1317',
      'F368J1E015',
      'NH1341E01',
      'PL101H01',
      'PL101HX01',
      'Poly 1267960',
      'QA-2-A-52',
      'RF2441E02',
      'WK2541E48',
      'XE151HXAG',
      'XK0441E56',
    ];
    const batchNumber4 = [
      '73200187',
      '21-A-484',
      '1614091-1',
      '1617072-2',
      '1617072-2',
      '311-9646',
      '311-9651',
      'RF2441E02',
    ];
    const batchNumber5 = ['14253', '5382-001'];

    // Convert image to base64 string
    const getBase64FromImage = (imgUrl) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = 'Anonymous';
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL('image/png');
          resolve(dataURL.split(',')[1]);
        };
        img.onerror = reject;
        img.src = imgUrl;
      });
    };

    // Add logo to the worksheet
    const base64Image = await getBase64FromImage(logoCrc);
    const imageId = workbook.addImage({
      base64: base64Image,
      extension: 'png',
    });

    // Add image with specific positioning and size
    addStationSheet.addImage(imageId, {
      tl: { col: 0, row: 0 },
      br: { col: 2, row: 1 },
      editAs: 'oneCell',
    });

    // Add title row and merge cells
    const titleRow = addStationSheet.getRow(1);
    titleRow.height = 40;

    // First clear any existing content in the title row
    titleRow.eachCell((cell) => {
      cell.value = null;
    });

    // Merge cells for title
    addStationSheet.mergeCells('A1:V1');

    // Set title cell properties
    const titleCell = titleRow.getCell(1);
    titleCell.value = 'SGS Form';
    titleCell.font = {
      size: 16,
      bold: true,
      name: 'Arial',
    };
    titleCell.alignment = {
      horizontal: 'center',
      vertical: 'middle',
      wrapText: true,
    };
    titleCell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE0E0E0' }, // Light gray background
    };

    // Ensure the title is visible
    addStationSheet.getColumn(1).width = 20;

    // Add column headers in row 2
    const columnHeaderRow = addStationSheet.getRow(2);
    columnHeaderRow.height = 40;

    // Clear any existing content in row 2
    columnHeaderRow.eachCell((cell) => {
      cell.value = null;
    });

    // Define columns with headers
    const columns = [
      { header: 'File Name', key: 'FileName', width: 20 },
      { header: 'Project Name', key: 'projectName', width: 20 },
      { header: 'Test Type', key: 'TestType', width: 20 },
      { header: 'Time line', key: 'timeline', width: 15 },
      { header: 'Temperature', key: 'temperature', width: 15 },
      { header: 'Company', key: 'company', width: 20 },
      { header: 'Contractor', key: 'contractor', width: 20 },
      { header: 'Report Number', key: 'reportNumber', width: 15 },
      { header: 'Purchase Order', key: 'purchaseOrder', width: 15 },
      { header: 'Results', key: 'results', width: 15 },
      { header: 'Tested Date', key: 'testedDate', width: 15 },
      { header: 'Reported Date', key: 'reportedDate', width: 15 },
      { header: 'Material 1', key: 'material1', width: 20 },
      { header: 'Batch Number 1', key: 'batchNumber1', width: 15 },
      { header: 'Material 2', key: 'material2', width: 20 },
      { header: 'Batch Number 2', key: 'batchNumber2', width: 15 },
      { header: 'Material 3', key: 'material3', width: 20 },
      { header: 'Batch Number 3', key: 'batchNumber3', width: 15 },
      { header: 'Material 4', key: 'material4', width: 20 },
      { header: 'Batch Number 4', key: 'batchNumber4', width: 15 },
      { header: 'Material 5', key: 'material5', width: 20 },
      { header: 'Batch Number 5', key: 'batchNumber5', width: 15 },
    ];

    // Set columns and apply headers to row 2
    addStationSheet.columns = columns;

    // Apply headers to row 2
    columns.forEach((col, index) => {
      const cell = columnHeaderRow.getCell(col.key);
      cell.value = col.header;
      cell.font = {
        bold: true,
        color: { argb: 'FFFFFFFF' }, // White text
      };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFEF314C' }, // Added FF for full opacity
      };
    });

    // Ensure all cells in row 2 are properly formatted
    for (let i = 1; i <= columns.length; i++) {
      const cell = columnHeaderRow.getCell(i);
      if (!cell.value) {
        cell.value = columns[i - 1].header;
        cell.font = {
          bold: true,
          color: { argb: 'FFFFFFFF' }, // White text
        };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFEF314C' }, // Added FF for full opacity
        };
      }
    }

    // Update dropdown options to start from row 3
    await addDropdownOptions(addStationSheet, 'B', projectNames, 3);
    await addDropdownOptions(addStationSheet, 'C', testType, 3);
    await addDropdownOptions(addStationSheet, 'D', timeline, 3);
    await addDropdownOptions(addStationSheet, 'E', temperature, 3);
    await addDropdownOptions(addStationSheet, 'F', Company, 3);
    await addDropdownOptions(addStationSheet, 'G', contractor, 3);
    await addDropdownOptions(addStationSheet, 'M', material1, 3);
    await addDropdownOptions(addStationSheet, 'N', batchNumber1, 3);
    await addDropdownOptions(addStationSheet, 'O', material2, 3);
    await addDropdownOptions(addStationSheet, 'P', batchNumber2, 3);
    await addDropdownOptions(addStationSheet, 'Q', material3, 3);
    await addDropdownOptions(addStationSheet, 'R', batchNumber3, 3);
    await addDropdownOptions(addStationSheet, 'S', material4, 3);
    await addDropdownOptions(addStationSheet, 'T', batchNumber4, 3);
    await addDropdownOptions(addStationSheet, 'U', material5, 3);
    await addDropdownOptions(addStationSheet, 'V', batchNumber5, 3);

    // Generate and download Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'SGS Front Sheet.xlsx';
    link.click();
  };

  const onRowDragEnd = (event) => {
    const { node, overNode } = event;
    if (!overNode) return;

    const draggedRow = node.data;
    const fromIndex = node.rowIndex;
    const toIndex = overNode.rowIndex;

    if (fromIndex === toIndex) return;

    const newRowData = [...rowData];
    newRowData.splice(fromIndex, 1);
    newRowData.splice(toIndex, 0, draggedRow);

    setRowData(newRowData);
  };

  const gridStyle = useMemo(() => ({ height: '100%', width: '100%' }), []);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      minWidth: 200,
      floatingFilter: true,
      resizable: true,
      enableValue: true,
      enableRowGroup: true,
      enablePivot: true,
      filter: 'agMultiColumnFilter',
      filterParams: {
        filters: [
          {
            filter: 'agTextColumnFilter',
            filterParams: {
              filterOptions: ['contains', 'equals', 'startsWith', 'endsWith'],
              buttons: ['reset'],
            },
          },
          {
            filter: 'agSetColumnFilter',
            filterParams: {
              buttons: ['reset'],
            },
          },
        ],
      },
      headerClass: 'ag-center-header',
      cellStyle: { textAlign: 'center' },
    };
  }, []);
  const activeKeyLine = 'Coating Test Repository';

  const defaultExcelExportParams = useMemo(() => {
    return {
      fileName: `${activeKeyLine}.xlsx`, // Default file name
      allColumns: true, // Include all columns by default
      onlySelected: false, // Include all rows, not just selected ones
      sheetName: 'Sheet1', // Default sheet name
    };
  }, [activeKeyLine]);
  const defaultCsvExportParams = useMemo(() => {
    return {
      fileName: `${activeKeyLine}.csv`, // Default file name
      allColumns: true, // Include all columns by default
      onlySelected: false, // Include all rows, not just selected ones
    };
  }, [activeKeyLine]);

  const rowSelection = useMemo(() => {
    return {
      mode: 'singleRow',
      checkboxes: false,
      enableClickSelection: true,
    };
  }, []);

  const onGridReady = useCallback(
    (params) => {
      console.log('on Called get ready', isLoading);
      if (isLoading) {
        params.api.showLoadingOverlay();
      } else {
        params.api.hideOverlay();
      }
    },
    [isLoading]
  );

  // // Update loading state
  // useEffect(() => {
  //     if (gridRef.current && gridRef.current.api) {
  //         if (isLoading) {
  //             gridRef.current.api.showLoadingOverlay();
  //         } else {
  //             gridRef.current.api.hideOverlay();
  //         }
  //     }
  // }, [isLoading]);

  // // Update loading state
  // useEffect(() => {
  //     if (gridRef.current && gridRef.current.api) {
  //         if (isLoading) {
  //             gridRef.current.api.showLoadingOverlay();
  //         } else {
  //             gridRef.current.api.hideOverlay();
  //         }
  //     }
  // }, [isLoading]);

  const [statusBar] = useState({
    statusPanels: [
      {
        statusPanel: 'agTotalRowCountComponent',
        align: 'left',
      },
      {
        statusPanel: 'agSelectedRowCountComponent',
        align: 'left',
      },
      {
        statusPanel: 'agFilteredRowCountComponent',
        align: 'left',
      },
    ],
  });

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 200,
      pinned: 'left',
    };
  }, []);

  const onSelectionChanged = () => {
    const selectedRows = gridRef.current.api.getSelectedRows();
    console.log('Selected Row Details:', selectedRows);
    seteditRecord(selectedRows);
    // You can do further processing with selectedRows here, e.g., updating state
  };

  return (
    <div className="flex-auto">
      {!showTestPage && (
        <div className="flex-auto">
          <div className="d-flex mb-3 align-items-center tab-content-title">
            <div className="back_heatp_modal">
              <Tooltip title={'Back'}>
                <ArrowLeftOutlined
                  onClick={() => {
                    history.push('/technical');
                  }}
                />
              </Tooltip>
            </div>

            <Title
              className="mb-0 add-new-calibration"
              level={3}
              style={{ paddingLeft: '25px', paddingTop: '5px' }}
            >
              Coating Test Repository
            </Title>

            <div className="new-calibration">
              <Text
                className="ps-3 add-new-calibration"
                style={{ marginTop: '10px', marginRight: '20px' }}
              >
                Filters Count: {listCount} / {listTotalCount}
              </Text>
              {/* <Tag> Results:{countValue('Results', '_')}</Tag> */}
              {/* <Tag> status: {listCount}</Tag>
                                <Tag> status: {listCount}</Tag> */}

              {/* <Button shape="round" key="apply" type="primary" onClick={showDrawer} style={{ marginLeft: '20px' }}>
                                <FilterOutlined style={{ fontSize: '20px' }}> </FilterOutlined>Filter
                            </Button>

                            <Button shape="round" key="apply" type="primary" style={{ marginLeft: '20px' }}
                                onClick={() => handleDownloadFilterTable(projectList)}
                                className="ps-3 add-new-calibration" loading={exportLoading}>

                                Export to Excel
                            </Button> */}
              {/* <Text onClick={showDrawer} className="ps-3" >
                                <FilterOutlined className='TestrepoIconRed' style={{ marginRight: '5px' }}> </FilterOutlined>
                                Filter
                            </Text> */}

              {/* <Button shape="round" key="apply" type="primary" style={{ marginLeft: '20px' }}
                                onClick={() => handleDownloadSGSFrontSheetTemplate()}
                                className="ps-3 add-new-calibration" >

                                Download SGS Front Sheet
                            </Button> */}
            </div>
          </div>
          <div className="custom-line" />

          <Row gutter={24}>
            <Col span={24}>
              <div className="addTeamDetails">
                <div
                  style={{ height: 'calc(112vh - 200px)', overflow: 'auto', position: 'relative' }}
                >
                  <div
                    className={`ag-grid ${theme} custom-grid-theme`}
                    style={gridStyle}
                  >
                    <AgGridReact
                      ref={gridRef}
                      rowData={rowData || []}
                      columnDefs={columnDefs}
                      rowDragManaged={true}
                      onRowDragEnd={onRowDragEnd}
                      defaultColDef={defaultColDef}
                      rowSelection={rowSelection}
                      onGridReady={onGridReady}
                      sideBar={true}
                      //
                      pivotPanelShow={'always'}
                      autoGroupColumnDef={autoGroupColumnDef}
                      animateRows={true}
                      onSelectionChanged={onSelectionChanged}
                      // enableFilter={true}
                      statusBar={statusBar}
                      rowHeight={40}
                      headerHeight={50}
                      defaultExcelExportParams={defaultExcelExportParams}
                      defaultCsvExportParams={defaultCsvExportParams}
                      loadingOverlayComponent={CustomLoadingCellRenderer}
                      loadingOverlayComponentParams={{
                        loadingMessage: 'Loading all rows...',
                      }}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      )}
      {showAddNewModal && (
        <UpdateReport
          showAddNewModal={showAddNewModal}
          setShowAddNewModal={setShowAddNewModal}
          addNewForm={addNewForm}
          isEdit={isEdit}
          setIsEdit={setIsEdit}
          seteditRecord={seteditRecord}
          editRecord={editRecord}
        ></UpdateReport>
      )}
      {showTestPage && (
        <TechnicalReportPage
          showTestPage={showTestPage}
          setshowTestPage={setshowTestPage}
          setSelectedRow={setSelectedRow}
          selectedRow={selectedRow}
        ></TechnicalReportPage>
      )}

      <Modal
        className="pipeline-modal"
        title="Results"
        centered
        visible={resultModalVisible}
        footer={[
          <Button
            key="apply"
            type="primary"
            onClick={() => setResultModalVisible(false)}
          >
            {'Ok'}
          </Button>,
        ]}
      >
        <div>{resultModalVisible && renderKeyValuePairs(selectedRow.Results)}</div>
      </Modal>
    </div>
  );
};
const mapStateToProps = ({ CrceTechnicalReducer }) => {
  const projectList = get(CrceTechnicalReducer, 'ProjectList', []);
  const isLoading = get(CrceTechnicalReducer, 'isProjectListLoading', false);

  const listCount = get(CrceTechnicalReducer, 'ProjectListCount', null);
  const listTotalCount = get(CrceTechnicalReducer, 'ProjectListTotalCount', null);

  return {
    projectList,
    isLoading,
    listCount,
    listTotalCount,
  };
};

const mapDispatchToProps = {
  onProjectList: fetchProjectList,
};

export default connect(mapStateToProps, mapDispatchToProps)(TechnicalPageAgGrid);
